module.exports = __webpack_public_path__ + "static/img/img_logo_4.02d48422.png";